import React from 'react';
import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChessKnight } from '@fortawesome/free-solid-svg-icons';
import AppContext from '../context/AppContext';
import { useAppDispatch, useAppSelector } from '../store';
import { closePlayOut } from '../reducers/uiReducer';
import { analytics } from '../utils/analytics';
import PlayOutBoard from './PlayOutBoard';

// "Play it out" as an overlay, stacked on the repair reveal or the game overlay's practice panel, so
// it stays small: board, level, a way back. Nothing is saved: a what-if on a position from the
// viewer's own game, never a fresh game (see "What we delay" in docs/02_areas/strategy/roadmap.md).
export default function PlayOutModal(): React.ReactNode {
  const dispatch = useAppDispatch();
  const { isMobile } = React.useContext(AppContext);
  const playOut = useAppSelector((state) => state.uiReducer.playOut);

  if (playOut == null) return null;

  const close = () => dispatch(closePlayOut());

  return (
    <Modal
      show={true}
      onHide={close}
      dialogClassName="cm-playout-modal"
      fullscreen={isMobile ? true : undefined}
      centered={!isMobile}
    >
      <Modal.Header closeButton>
        <Modal.Title className="cm-playout-modal-title">
          <FontAwesomeIcon icon={faChessKnight} className="me-2" />
          Play it out
          {playOut.label ? (
            <span className="cm-playout-modal-scope text-muted"> · {playOut.label}</span>
          ) : null}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="cm-playout-intro text-muted">
          Your position, from here. See whether you can actually finish it off — nothing here is
          saved.
        </p>
        <PlayOutBoard
          startFen={playOut.fen}
          playerColor={playOut.color}
          startEvalCp={playOut.evaluationCp}
          onFinished={(outcome, levelKey) =>
            analytics.track('play_out_result', { outcome, level: levelKey })
          }
        />
      </Modal.Body>
    </Modal>
  );
}
